import React from "react";
import img from "../../img/cartoon cscyle.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useState } from "react";
import { useEffect } from "react";
import img2 from "../../img/quote.png";
const ToCarusel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const [data, setdata] = useState([]);
  useEffect(() => {
    fetch("fakedb.json")
      .then((response) => response.json())
      .then((data) => setdata(data));
  }, []);

  return (
    <div className="flex h-[345px] text-white  bg-red-500 flex-col lg:flex-row-reverse mb-5 items-center justify-around">
      <div className="w-1/2 h-full">
        <img src={img} class=" " alt="" />
      </div>
      <div className="w-1/2">
        <p className="p-10">
          <div>
            <Slider {...settings}>
              <div className="p-8">
                <img className="h-[30px]" src={img2} alt="" />
                <h3>
                  Multi-modal container units, designed as reusable carriers to
                  facilitate unit load handling of the goods contained, are also
                  referred to as cargo, specially by shipping lines and
                  logistics operators.
                </h3>
              </div>
              <div className="p-8">
                <img className="h-[30px]" src={img2} alt="" />
                <h3>
                  Multi-modal container units, designed as reusable carriers to
                  facilitate unit load handling of the goods contained, are also
                  referred to as cargo, specially by shipping lines and
                  logistics operators.
                </h3>
              </div>
              <div className="p-8">
                <img className="h-[30px]" src={img2} alt="" />
                <h3>
                  Multi-modal container units, designed as reusable carriers to
                  facilitate unit load handling of the goods contained, are also
                  referred to as cargo, specially by shipping lines and
                  logistics operators.
                </h3>
              </div>
            </Slider>
          </div>
        </p>
      </div>
    </div>
  );
};

export default ToCarusel;
